// ParentComponent.js (or Exam.js)
import React from 'react';
import ExamCalendar from '../../components/ExamCalender/ExamCalendar';
import ExamResults from '../../components/ExamResult/ExamResult';
import QuestionPaper from '../../components/QuestionPaper/QuestionPaper';
import './Exam.css';  // Assuming you're using an external CSS file

const Exam = () => {
  return (
    <div className='exam-container'>
     
      <div className='exam-section'>
        <ExamCalendar />
      </div>
      <div className='exam-section'>
        <ExamResults />
      </div>
      <div className='exam-section'>
        <QuestionPaper />
      </div>
      
    </div>
  );
};

export default Exam;
